var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"num-text-box"},_vm._l((_vm.numStr),function(item){return _c('div',{class:("num-text type-" + _vm.type + " n" + item)})}))}
var staticRenderFns = []

export { render, staticRenderFns }